import { Grid, Typography } from "@mui/material";
import { useUserControl } from "../../context/SuperAdmin/UserControlContext";
import { Spinner } from "../../components/Loading/Spinner";
import HeadersAllUsers from "../../components/Table/UserControl/HeadersAllUsers";
import UsersTable from "../../components/Table/UserControl/UsersTable";

const UserContolPage = () => {
  const { isLoadingUsers } = useUserControl();
  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Gestor de Usuarios</b> | Usuarios
        </Typography>
      </Grid>

      {/* Busqueda y fitrado de usuarios */}
      <Grid item>
        <HeadersAllUsers />
      </Grid>

      {isLoadingUsers ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Tabla de usuarios */}
          <Grid item>
            <UsersTable />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default UserContolPage;
